import EditDealershipForm from './EditDealershipForm';

export default EditDealershipForm;
